// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"84":"2055a928","144":"9289e348","203":"2055a928","264":"9289e348","387":"2055a928","913":"2055a928"}[chunkId] + ".chunk.css";
};